import { HttpClient } from '@angular/common/http';
import { Component, ElementRef, Input, OnChanges, OnInit, ViewChild } from '@angular/core';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import { ImageViewer } from 'iv-viewer';
import { ngxLoadingAnimationTypes } from 'ngx-loading';
import * as Queue from 'promise-queue/lib';
import { map } from 'rxjs/operators';

const PrimaryWhite = '#ffffff';
const SecondaryGrey = '#ccc';

@Component({
  selector: 'img-ajax',
  templateUrl: './img-ajax.component.html',
  styleUrls: ['./img-ajax.component.scss'],
})
export class ImgAjaxComponent implements OnInit, OnChanges {
  public ngxLoadingAnimationTypes = ngxLoadingAnimationTypes;
  public primaryColour = PrimaryWhite;
  public secondaryColour = SecondaryGrey;

  @Input() queue: Queue;

  @Input() src: string;
  @Input() orientation: number;
  @Input() zoom: boolean;
  @Input() snapView = true;
  zoomViewer: ImageViewer;

  imgData: SafeUrl;

  @ViewChild('imgTag', { static: true }) imgTag: ElementRef;

  cssClass = '';
  loaded = false;

  setCssClass() {
    if (this.orientation) {
      switch (this.orientation) {
        case 3:
          this.cssClass = 'orientation180';
          break;

        case 6:
          this.cssClass = 'orientation90';
          break;

        case 8:
          this.cssClass = 'orientation270';
          break;
      }
    } else {
      this.cssClass = '';
    }
  }

  constructor(
    private httpClient: HttpClient,
    private domSanitizer: DomSanitizer,
  ) {}

  ngOnInit() {
    // blank placeholder
    this.imgData = this.domSanitizer.bypassSecurityTrustUrl(
      'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAADUlEQVR42mP8z/C/HgAGgwJ/lK3Q6wAAAABJRU5ErkJggg==',
    );
  }

  async ngOnChanges() {
    this.loaded = false;

    if (this.zoomViewer) {
      // remove past snapshot while loading next image
      this.zoomViewer.destroy();
      delete this.zoomViewer;
    }

    if (this.src) {
      try {
        if (this.queue) {
          this.imgData = await this.queue.add(() =>
            this.httpClient
              .get(`${this.src}`, { responseType: 'blob' })
              .pipe(
                map(e => {
                  return this.domSanitizer.bypassSecurityTrustUrl(URL.createObjectURL(e));
                }),
              )
              .toPromise(),
          );
        } else {
          this.imgData = await this.httpClient
            .get(`${this.src}`, { responseType: 'blob' })
            .pipe(
              map(e => {
                return this.domSanitizer.bypassSecurityTrustUrl(URL.createObjectURL(e));
              }),
            )
            .toPromise();
        }

        this.setCssClass();

        const img: HTMLImageElement = this.imgTag.nativeElement;
        if (img) {
          img.onload = () => {
            this.loaded = true;
            if (this.zoom) {
              if (this.zoomViewer) {
                this.zoomViewer.load(img.src);
              } else {
                this.zoomViewer = new ImageViewer(img, {
                  snapView: this.snapView,
                });
              }
            }
          };
        }
      } catch (e) {
        console.log(`Image `, this.src, ` could not be loaded`);
      }
    }
  }
}
